import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import JoinLeftIcon from '@mui/icons-material/JoinLeft';
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import DatasetIcon from '@mui/icons-material/Dataset';
import AbcIcon from '@mui/icons-material/Abc';
import PollOutlinedIcon from '@mui/icons-material/PollOutlined';
import BrowserNotSupportedIcon from '@mui/icons-material/BrowserNotSupported';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BarChartIcon from '@mui/icons-material/BarChart';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SettingsIcon from '@mui/icons-material/Settings';

import options from './options';

const attributes = {
    accountGoogle: { name: 'subject', type: 'input', label: 'Account' }, //, icon: <AccountCircleIcon />
    actions: { name: 'action', type: 'select', label: 'Action', options: options.actions },
    actionsGoogle: { name: 'action', type: 'select', label: 'Action', options: options.actionsGoogle }, //, icon: <SettingsIcon />
    automationId: { name: 'automationId', type: 'input', label: 'Automation ID', required: true },
    directoryId: { name: 'directoryId', type: 'input', label: 'Directory ID', required: true },
    distributionChannel: { name: 'DistributionChannel', type: 'input', label: 'Distribution Channel', required: true }, //, icon: <AbcIcon />
    file_type: { name: 'file_type', type: 'select', label: 'File Type', options: options.file_type, icon: <InsertDriveFileOutlinedIcon /> }, //, icon: <InsertDriveFileOutlinedIcon />,
    folder: { name: 'folder', type: 'input', label: 'Folder', icon: <FolderOutlinedIcon /> },
    googlesheetId: { name: 'googlesheetId', label: 'Google Sheet ID', required: true, type: 'input', icon: <DatasetIcon />, launch: 'https://drive.google.com/open?id=' },
    mailingListId: { name: 'mailingListId', type: 'input', label: 'Mailing List ID', required: true },
    noHeaders: { name: 'noHeaders', type: 'select', label: 'No Headers', icon: <BrowserNotSupportedIcon />, options: options.noHeaders },
    object_key: { name: 'object_key', type: 'input', label: 'File Path', icon: <InsertDriveFileOutlinedIcon /> }, //
    query: { name: 'queryId', type: 'select', label: 'Query', launch: '/queries/', icon: <JoinLeftIcon /> }, //
    querygql: { name: 'query', type: 'sqleditor', label: 'GraphQL Query' }, //, icon: <JoinLeftIcon />
    sheet: { name: 'sheet', label: 'Sheet Name', required: true, type: 'input' }, //, icon: <AbcIcon />
    surveyId: { name: 'surveyId', type: 'input', label: 'Survey ID', required: true, icon: <PollOutlinedIcon /> },
    surveyType: { name: 'surveyType', type: 'select', label: 'Survey Type', options: options.qualtricsSurveyTypes },
    tableau: { name: 'tableau', type: 'tableau', label: 'Tableau' },
    tableauUrl: { name: 'tableauUrl', type: 'input', label: 'Tableau URL', icon: <BarChartIcon /> },
    tableauParameter: { name: 'tableauParameter', type: 'select', label: 'Tableau Parameter', icon: <FilterAltIcon /> },
    tableauParameterValues: { name: 'tableauParameterValues', type: 'input', label: 'Tableau Parameter Values', disabled: true, icon: <SettingsIcon /> },

    host: { label: "URL", type: "input" },
    url: { label: "URL", type: "input" },
    url_auth: { label: "URL (Authentication)", type: "input" },
    url_data: { label: "URL (Data)", type: "input" },
    redirect_uri: { label: "Redirect URI", type: "input" },
    port: { label: "Port", type: "input" },
    // folder: {label: "Folder", type: "input"},
    username: { label: "Username", type: "input" },
    password: { label: "Password", type: "password" },
    pwd: { label: "Password", type: "password" },
    server: { label: "Host", type: "input" },
    database: { label: "Database", type: "input" },
    schema: { label: "Default Schema (Optional)", type: "input" },
    domain: { label: "Domain", type: "input" },
    subdomain: { label: "Subdomain", type: "input" },
    sitename: { label: "Site Name", type: "input" },
    apikey: { label: "API Key", type: "password" },
    apikeys: { label: "API Keys", type: "apikeys" },
    token: { label: "API Token", type: "password" },
    tenant_id: { label: "Tenant ID", type: "password" },
    client_id: { label: "Client ID", type: "password" },
    client_secret: { label: "Client Secret", type: "password" },
    security_token: { label: "API Token", type: "password" },
    organizationId: { label: "Organization ID", type: "input" },
    admin_account: { label: "Admin Account", type: "input" },
    credentials: { label: "Credentials", type: "password", multiline: true },
    cookie: { label: "Cookie", type: "password", multiline: true },
    consumer_key: { label: "Consumer Key", type: "password" },
    consumer_secret: { label: "Consumer Secret", type: "password" },
    access_token: { label: "Access Token", type: "password" },
    refresh_token: { label: "Refresh Token", type: "password" },
    service_account: { label: "Service Account", type: "input" },
    delegate_account: { label: "Delegate Account", type: "input" }
}

export default attributes;